export const NEW = 1;
export const ACCEPTED = 2;
export const FINISHED = 3;
export const REJECTED = 4;
export const CANCELLED = 5;
export const LATE_CANCELLATION = 6;

export default Object.freeze({
  NEW,
  ACCEPTED,
  FINISHED,
  REJECTED,
  CANCELLED,
  LATE_CANCELLATION
});
